export var Scope;
(function (Scope) {
    Scope["ITEMS_READ"] = "items:read";
    Scope["COINS_READ"] = "coins:read";
    Scope["IDENTIFY"] = "identify";
})(Scope || (Scope = {}));
//# sourceMappingURL=scope.js.map